import { useQuery } from "@apollo/client";
import { useAuth } from "@frontegg/react";
import { GET_USER } from "graphql/user";
import { useEffect, useState } from "react";

export interface User {
  id: string;
  companyId: string;
  platformId: string;
  departmentId: string;
  firstName: string;
  lastName?: string | null;
  profilePicUrl?: string | null;
  email: string;
  phoneNumber: string | null;
  birthdate: Date | null;
  role: string;
  hasPhysicalCard: boolean;
  address: Address | null;
  isBirthday?: boolean | null;
}

interface Address {
  addressName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipcode: string;
}

type LoggedInUser = {
  user: User | null;
  loading: boolean;
};

const useGetLoggedInUser = (): LoggedInUser => {
  const { user: loggedInUser } = useAuth();
  const [user, setUser] = useState<User | null>(null);

  const { data: userData, loading } = useQuery(GET_USER, {
    variables: { userId: loggedInUser?.sub },
  });

  useEffect(() => {
    if (userData) {
      const u = userData.user;

      // Calculate isBirthday
      let isBirthday = false;
      if (u.birthdate) {
        const birthDate = new Date(u.birthdate);
        const today = new Date();

        // Compare local month and day
        isBirthday =
          birthDate.getMonth() === today.getMonth() &&
          birthDate.getDate() === today.getDate();
      }
      setUser({
        id: u.id,
        companyId: u.company.id,
        platformId: u.platformId,
        departmentId: u.department.id,
        firstName: u.firstName,
        lastName: u.lastName,
        email: u.email,
        phoneNumber: u.phone,
        birthdate: u.birthdate,
        role: u.role,
        hasPhysicalCard: u.hasPhysicalCard,
        address: u.address,
        isBirthday,
      });
    }
  }, [userData]);

  return { user, loading };
};

export default useGetLoggedInUser;
